"use client";

import { Button, ButtonProps } from "@/components/atoms/Button";
import ChevronDownIcon from "@/icons/__generated__/ChevronDown/ChevronDown20";
import { cn } from "@/lib/utils";
import * as React from "react";

export type ComboboxTriggerProps = ButtonProps & {
  errorMsg?: string;
  readOnly?: boolean;
  selectedOption?: { value: string; label: string };
  placeholder?: React.ReactNode;
  children?: React.ReactNode;
};

export const ComboboxTrigger = React.forwardRef<
  HTMLButtonElement,
  ComboboxTriggerProps
>(
  (
    {
      errorMsg,
      fullWidth,
      readOnly,
      disabled,
      value,
      className,
      children,
      testId = "combobox-trigger",
      ...props
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        testId={testId}
        suffix={
          <ChevronDownIcon
            className={cn({
              "tw-text-gray-900": !disabled,
            })}
          />
        }
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outline-1"
        appearance="white"
        value={value}
        {...props}
        className={cn(
          "[&>span]:tw-inline-flex [&>span]:tw-justify-between [&>span]:tw-flex-1 tw-body-2 hover:tw-bg-base-white",
          {
            "tw-pointer-events-none": readOnly,
            "tw-text-gray-600": !value && !disabled,
            "tw-border-red-800": !!errorMsg,
          },
          className,
        )}
      >
        {children}
      </Button>
    );
  },
);
ComboboxTrigger.displayName = "ComboboxTrigger";
